module.exports = __webpack_public_path__ + "img/logo_minex.b1a6ee80.png";